import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { port } from "../../../../adblockplusui/adblockpluschrome/lib/messaging/port.js";
export function start() {
    port.on("testing.setRemoteConfigUrl", (message) => {
        ewe.remoteConfig.setUrl(message.url);
    });
    port.on("testing.syncRemoteConfig", async () => {
        await ewe.remoteConfig.sync();
    });
}
